"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ComboboxTextArea = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _designTokensReact = require("@smartsheet/design-tokens-react");
var _withFocusClassName = require("../../../../util/withFocusClassName");
var _menuTheme = require("../../../menu/styled/menuTheme");
var _textareaV = require("../../../textareaV2");
const ComboboxTextArea = (0, _withFocusClassName.withFocusToggleClassName)((0, _styled.default)(_textareaV.TextAreaV2)`
    display: block;
    width: 100%;
    border: none;
    color: ${(0, _designTokensReact.color)("color--text--neutral--strong")};

    // Override some UA styles.
    font-family: inherit;
    font-size: ${_ref => {
  let {
    themeMode
  } = _ref;
  return _menuTheme.menuTheme.fontSize(themeMode);
}};

    &:focus-within::before {
        border: none;
        box-shadow: none;
    }
`);
exports.ComboboxTextArea = ComboboxTextArea;
//# sourceMappingURL=ComboBoxTextArea.js.map